// Code generated by Slice Machine. DO NOT EDIT.

import dynamic from 'next/dynamic';

export const components = {
  about_swiftask_and_resources: dynamic(
    () => import('./AboutSwiftaskAndResources'),
  ),
  ai_agent_onboarding: dynamic(() => import('./NewAiAgentOnboarding')),
  banner_cta: dynamic(() => import('./NewHomeBannerCta')),
  bot_credits: dynamic(() => import('./BotCredits')),
  bot_info_slice: dynamic(() => import('./BotInfoSlice')),
  button_app: dynamic(() => import('./ButtonAppMobile')),
  case_security: dynamic(() => import('./CaseSecurity')),
  chat_bot_ai: dynamic(() => import('./ChatBotAi')),
  chatbot_business: dynamic(() => import('./ChatbotBusiness')),
  chatbot_install: dynamic(() => import('./ChatbotInstall')),
  contact: dynamic(() => import('./Contact')),
  customer_logos: dynamic(() => import('./CustomerLogos')),
  customer_use_cases: dynamic(() => import('./CustomerUseCases')),
  disign_faq: dynamic(() => import('./DisignFaq')),
  faq: dynamic(() => import('./Faq')),
  feature_screenshot: dynamic(() => import('./FeatureScreenshot')),
  features: dynamic(() => import('./Features')),
  hero2: dynamic(() => import('./Hero2')),
  home_info: dynamic(() => import('./HomeInfo')),
  homebanner: dynamic(() => import('./Homebanner')),
  homes_banner: dynamic(() => import('./NewHomeBanner')),
  image_block: dynamic(() => import('./ImageBlock')),
  key_indicator1: dynamic(() => import('./KeyIndicator1')),
  list_grouped1: dynamic(() => import('./ListGrouped1')),
  list_grouped2: dynamic(() => import('./ListGrouped2')),
  // liste_menu_use_case: dynamic(() => import('./ListeMenuUseCase')),
  logo_enterprise: dynamic(() => import('./LogoEnterprise')),
  new_customer_testimonial: dynamic(() => import('./NewCustomerTestimonial')),
  new_faq: dynamic(() => import('./NewFaq')),
  new_get_started_swiftask: dynamic(() => import('./NewGetStartedSwiftask')),
  new_testimonial: dynamic(() => import('./NewTestimonial')),
  our_company: dynamic(() => import('./OurCompany')),
  our_organisation: dynamic(() => import('./OurOrganisation')),
  our_team: dynamic(() => import('./OurTeam')),
  plan_feature: dynamic(() => import('./PlanFeature')),
  pricing: dynamic(() => import('./Pricing')),
  pricing_plan_detils: dynamic(() => import('./PricingPlanDetils')),
  product_features_overview: dynamic(() => import('./ProductFeaturesOverview')),
  section_grid: dynamic(() => import('./SectionGrid')),
  section_grid2: dynamic(() => import('./SectionGrid2')),
  section_image_and_list: dynamic(() => import('./SectionImageAndList')),
  start_info: dynamic(() => import('./StartInfo')),
  testimonial: dynamic(() => import('./Testimonial')),
  testimonial_company: dynamic(() => import('./TestimonialCompany')),
  text: dynamic(() => import('./Text')),
  three_card: dynamic(() => import('./ThreeCard')),
  title_description: dynamic(() => import('./TitleDescription')),
  title_descripton: dynamic(() => import('./TitleDescripton')),
  upgrade_steps: dynamic(() => import('./UpgradeSteps')),
  use_case_card2: dynamic(() => import('./UseCaseCard2')),
  use_case_card3: dynamic(() => import('./UseCaseCard3')),
  why_swiftask: dynamic(() => import('./WhySwiftask')),
  why_swiftask_id_difference: dynamic(
    () => import('./WhySwiftaskIsDifference'),
  ),
};
